<template>
  <div style="border: 1px solid #d7d7d7">
    <div
      ref="editor"
      :style="`height: ${height}`"
      class="monaco"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-console, no-unused-vars */
import * as monaco from 'monaco-editor';

export default {
  props: {
    value: {
      type: String,
      default: () => '',
    },
    language: {
      type: String,
      default: () => 'javascript',
    },
    theme: {
      type: String,
      default: () => 'vs-light',
    },
    height: {
      type: String,
      default: () => '500px',
    },
    disableValidateJson: {
      type: Boolean,
      default: false,
    },
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    const el = this.$refs.editor;
    this.editor = monaco.editor.create(el, {
      value: this.value,
      language: this.language,
      theme: this.theme,
      fontSize: 13,
      readOnly: this.disable,
    });

    if (this.disableValidateJson) {
      monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: false,
      });
    }
  },
  methods: {
    getData() {
      return this.editor.getValue();
    },
    changeLanguage(language) {
      const model = this.editor.getModel();
      model.getLanguageIdentifier();
      monaco.editor.setModelLanguage(model, language);
    },
    changeValue(value) {
      this.editor.getModel().setValue(value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .monaco {
    font-family: 'Poppins-Bold';
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monaco-editor/jMonacoEditor.vue